import React from 'react';
import { useShowContext } from 'framework/show';
import { Stack } from '@mui/material';
import CPITrendsChart from './charts/CPITrendsChart';
import BurndownChart from './charts/BurndownChart';

const EVMDataCharts = () => {
  const { data } = useShowContext();

  if (!data?.charts || data.charts.length === 0) {
    return <div>No chart data available</div>;
  }
  return (
    <Stack gap={4} sx={{ width: '100%', height: '400px', flexDirection: 'row' }}>
      <CPITrendsChart data={data.charts} />
      <BurndownChart data={data.charts} />
    </Stack>
  );
};

export default EVMDataCharts;
